import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

function MainContainer({ children = null }) {
    return (
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
            <Toolbar />
            <Box component="main" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', px: 4, py: 2 }}>
                {children}
            </Box>
        </Box>
    );
}

MainContainer.propTypes = {
    children: PropTypes.any,
}

export default MainContainer;
